import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditAssignmentSchool = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState("");
  const { id } = useParams();

  // Fetch existing assignment details
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosAssignment/${id}`)
      .then((response) => {
        const data = response.data;
        setTitle(data?.assignment || "");
        setLanguage(data?.language || "");
        setFile(null); // Reset file upload
      })
      .catch((error) => {
        console.error("Error fetching assignment details:", error);
      });
  }, [id, API_BASE_URL]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare form data for submission
    const formData = new FormData();
    formData.append("assignment", title);
    formData.append("language", language);
    if (file) {
      formData.append("assignmentpdfPath", file);
    }

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/niosAssignment/${id}`
        : `${API_BASE_URL}/admin/niosAssignment/${id}`;

    // Send PUT request to update assignment
    axios
      .put(
        // `${API_BASE_URL}/admin/niosAssignment/${id}`,
        endpoint,
        formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log("Assignment updated successfully:", response.data);
        alert("Assignment updated successfully.");
        navigate("/student-assignment/all-school");
      })
      .catch((error) => {
        console.error("Error updating assignment:", error);
        alert("Error updating assignment.");
      });
  };

  return (
    <div id="assignment-school-main-container">
      <div className="ass-school-heading-or-btns">
        <h4>Edit School Assignment</h4>
        <div className="ass-school-nav-btns">
          <button onClick={() => navigate("/student-assignment/school")}>
            School Assignment
          </button>
          <button onClick={() => navigate("/student-assignment/all-school")}>
            School All Assignments
          </button>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="assignment-school-inner-container">
          {/* Language Input */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Language</b>
            </label>
            <select
              className="p-2"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              required
            >
              <option value="">--Select Language--</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </div>

          {/* Title Input */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Title</b>
            </label>
            <input
              type="text"
              placeholder="Enter Title"
              className="p-2"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          {/* File Upload */}
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>File</b>
            </label>
            <input
              type="file"
              className="p-2 border"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>
        </div>
        <div className="ass-school-submit-btn">
          <button type="submit" className="blogAddSaveButton">
            Submit Assignment
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditAssignmentSchool;
